module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_two-e067da625e0e5eb2d60c0476b048636e.png";